exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".step--inception {\n  margin-top: 10px;\n  margin-bottom: 30px; }\n  .step--inception .header {\n    font-size: 24px; }\n  .step--inception .img {\n    text-align: center; }\n    .step--inception .img > img:not(:first-child) {\n      margin-top: 25px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Setup/components/scss/stepInception.scss
// module id = 903
// module chunks = 1